(function () {
  const ROTATE_MS = 3200;
  const ANIMATION_MS = 450;

  function parseTerms(raw) {
    try {
      const terms = JSON.parse(raw);
      return Array.isArray(terms) ? terms.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function initRotatingPlaceholder(root) {
    const inputId = root.dataset.inputId;
    const input = inputId ? document.getElementById(inputId) : root.parentElement?.querySelector('input[type="search"]');
    const terms = parseTerms(root.dataset.terms);

    if (!input || terms.length === 0) {
      root.hidden = true;
      return;
    }

    const activeEl = root.querySelector('.search-rotating-placeholder__term.is-active');
    const nextEl = root.querySelector('.search-rotating-placeholder__term.is-next');
    const track = root.querySelector('.search-rotating-placeholder__track');

    if (!activeEl || !nextEl || !track) return;

    let index = 0;
    let timer = null;
    let animating = false;

    const formatTerm = (term) => `"${term}"`;

    const syncVisibility = () => {
      const shouldHide =
        input.value.length > 0 ||
        document.activeElement === input ||
        input.matches(':focus');

      root.hidden = shouldHide;
      root.classList.toggle('is-hidden', shouldHide);

      if (shouldHide) {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      } else if (!timer) {
        startTimer();
      }
    };

    const hidePlaceholder = () => {
      root.hidden = true;
      root.classList.add('is-hidden');
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const setActiveText = (term) => {
      activeEl.textContent = formatTerm(term);
    };

    const advance = () => {
      if (animating || terms.length < 2 || root.hidden) return;

      const nextIndex = (index + 1) % terms.length;
      nextEl.textContent = formatTerm(terms[nextIndex]);
      animating = true;
      track.classList.add('is-animating');

      window.setTimeout(() => {
        index = nextIndex;
        track.style.transition = 'none';
        setActiveText(terms[index]);
        nextEl.textContent = '';
        track.classList.remove('is-animating');
        track.offsetHeight;
        track.style.transition = '';
        animating = false;
      }, ANIMATION_MS);
    };

    const startTimer = () => {
      if (timer) window.clearInterval(timer);
      timer = window.setInterval(advance, ROTATE_MS);
    };

    setActiveText(terms[0]);
    syncVisibility();
    if (!root.hidden) startTimer();

    input.addEventListener('mousedown', hidePlaceholder);
    input.addEventListener('click', hidePlaceholder);
    input.addEventListener('focus', hidePlaceholder);
    input.addEventListener('focusin', hidePlaceholder);
    input.addEventListener('input', hidePlaceholder);
    input.addEventListener('blur', syncVisibility);
    input.addEventListener('search', syncVisibility);

    root.addEventListener('search-rotating-placeholder:refresh', syncVisibility);
  }

  function initAll() {
    document.querySelectorAll('[data-search-rotating-placeholder]').forEach(initRotatingPlaceholder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
